export default "__VITE_ASSET__BtoGIHf1__"